import React from 'react'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import { Col, Row } from 'react-bootstrap'

import './SummaryReport.css'

export default function SummaryReport({ summaryReportData }) {
  console.log('summaryReportData', summaryReportData)
  return (
    <>
      {summaryReportData != [] && (
        <Tabs>
          <TabList>
            {summaryReportData.map((term, index) => (
              <Tab key={term.name}>
                <span>
                  {term.name} ({term.amountInt})
                </span>
              </Tab>
            ))}
          </TabList>
          {summaryReportData.map((data, index) => (
            <TabPanel key={index}>
              <Row>
                <Col md={4} className='container-info-key'>
                  <span>{data.amount}</span>
                  <br />
                  <span>{data.mAmount}</span>
                  <br />
                  <span>{data.fAmount}</span>
                  <br />
                  <span>{data.minAge}</span>
                  <br />
                  <span>{data.maxAge}</span>
                  <br />
                  <span>{data.avgAge}</span>
                  <br />
                </Col>
                <Col md={8} className='container-info-data'>
                  {data?.unitCountReport?.map((unitCountReport, index) => (
                    <Row>
                      <Col md={2}>{unitCountReport.name}</Col>
                      <Col md={10}>{unitCountReport.amount} คน</Col>
                    </Row>
                  ))}
                </Col>
              </Row>
            </TabPanel>
          ))}
        </Tabs>
      )}
    </>
  )
}
